var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c("section-title", { attrs: { icon: "mdi-file-upload-outline" } }, [
        _vm._v("Subida de documentos, tutoriales y URLs")
      ]),
      _c(
        "v-card",
        { staticClass: "pa-4 mb-12" },
        [
          _c(
            "v-form",
            { ref: "form", staticClass: "ma-4" },
            [
              _c(
                "v-row",
                { attrs: { dense: "", align: "center" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c("v-select", {
                        attrs: {
                          label: "Tipo de documento a subir",
                          items: _vm.documentTypes,
                          "item-text": "name",
                          "item-value": "type",
                          "prepend-icon": "mdi-text-box-search-outline",
                          rules: [_vm.rules.required()]
                        },
                        model: {
                          value: _vm.selectedType,
                          callback: function($$v) {
                            _vm.selectedType = $$v
                          },
                          expression: "selectedType"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.selectedType === 3
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-text-field", {
                            staticClass: "mr-2",
                            attrs: {
                              label: "URL del vídeo",
                              "prepend-icon": "mdi-youtube",
                              rules: [
                                _vm.rules.required(),
                                this.validYouTubeUrl()
                              ]
                            },
                            model: {
                              value: _vm.formAttributes.url,
                              callback: function($$v) {
                                _vm.$set(_vm.formAttributes, "url", $$v)
                              },
                              expression: "formAttributes.url"
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-file-input", {
                            ref: "file",
                            staticClass: "mr-2",
                            attrs: {
                              "show-size": "",
                              "truncate-length": "22",
                              counter: "",
                              "counter-size-string": "",
                              label: "Seleccionar archivo",
                              rules: [_vm.rules.required()]
                            },
                            on: { change: _vm.onFileChange },
                            model: {
                              value: _vm.formAttributes.file,
                              callback: function($$v) {
                                _vm.$set(_vm.formAttributes, "file", $$v)
                              },
                              expression: "formAttributes.file"
                            }
                          })
                        ],
                        1
                      ),
                  _vm.selectedType < 3
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Título del documento",
                              "prepend-icon": "mdi-subtitles-outline",
                              "persistent-hint": "",
                              rules: [_vm.rules.required()]
                            },
                            model: {
                              value: _vm.formAttributes.name,
                              callback: function($$v) {
                                _vm.$set(_vm.formAttributes, "name", $$v)
                              },
                              expression: "formAttributes.name"
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Título del vídeo",
                              "prepend-icon": "mdi-subtitles-outline",
                              "persistent-hint": "",
                              rules: [_vm.rules.required()]
                            },
                            model: {
                              value: _vm.formAttributes.name,
                              callback: function($$v) {
                                _vm.$set(_vm.formAttributes, "name", $$v)
                              },
                              expression: "formAttributes.name"
                            }
                          })
                        ],
                        1
                      ),
                  _c(
                    "v-col",
                    { staticClass: "text-right", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            loading: _vm.isLoading,
                            color: "green",
                            dark: "",
                            block: _vm.$vuetify.breakpoint.smAndDown
                          },
                          on: {
                            click: function() {
                              if (this$1.$refs.form.validate()) {
                                this$1.$refs.modal.openModal()
                              }
                            }
                          }
                        },
                        [
                          _c("v-icon", { staticClass: "mr-2" }, [
                            _vm._v("mdi-check-all")
                          ]),
                          _vm._v("Aceptar y Guardar")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "base-modal",
        {
          ref: "modal",
          attrs: {
            icon: "mdi-alert-outline",
            title: "Confirmación de sobreescritura"
          }
        },
        [
          _c(
            "v-col",
            { staticClass: "text-center" },
            [
              _c("div", { staticClass: "px-4 pt-6 caption" }, [
                _vm._v(
                  " Se sobreescribirán los documentos/vídeos con el mismo título. "
                )
              ]),
              _c("div", { staticClass: "pb-6 pt-2 px-4 override-question" }, [
                _vm._v(" ¿Está seguro de querer continuar? ")
              ]),
              _c(
                "v-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "mr-1" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            block: "",
                            color: "green",
                            dark: "",
                            loading: _vm.isLoading
                          },
                          on: {
                            click: function() {
                              return _vm.executeRequest()
                            }
                          }
                        },
                        [_vm._v("SÍ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "ml-1" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            block: "",
                            outlined: "",
                            disabled: _vm.isLoading,
                            color: "green"
                          },
                          on: {
                            click: function() {
                              this$1.$refs.modal.closeModal()
                            }
                          }
                        },
                        [_vm._v("NO")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }